import React, { useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// import { JVInput } from "../../shared/Hinput";

import { set } from "date-fns";
import { baseUrl } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVPasswordInput } from "../../shared/JVPasswordInput";

const emailSchema = yup.object({
  email: yup.string().email().required("Email is required*"),
});

const otpSchema = yup.object({
  otp: yup.string().required("OTP is required*"),
});

interface INewPassword {
  newPassword?: string;
  confirmPassword?: string;
}

const newPasswordSchema = yup.object({
  newPassword: yup
    .string()
    .min(8, "Password must be at least 8 characters long")
    .required("New password is required*"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword")], "Passwords must match")
    .required("Please confirm your password*"),
});

const ResetPassword = () => {
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(true);
  const toast = useRef<Toast>(null);

  const {
    control: emailControl,
    handleSubmit: handleEmailSubmit,
    formState: { errors: emailErrors },
    reset: resetEmailForm,
  } = useForm({
    resolver: yupResolver(emailSchema),
  });

  const {
    control: otpControl,
    handleSubmit: handleOtpSubmit,
    formState: { errors: otpErrors },
    reset: resetOtpForm,
  } = useForm({
    resolver: yupResolver(otpSchema),
  });

  const {
    control: newPasswordControl,
    handleSubmit: handleNewPasswordSubmit,
    formState: { errors },
    reset: resetNewPasswordForm,
  } = useForm<INewPassword>({
    resolver: yupResolver(newPasswordSchema),
    defaultValues: {},
    shouldFocusError: false,
  });

  const onSubmitEmail = async (data: any) => {
    try {
      setLoading(true);
      const response = await fetch(
        baseUrl + "External_User_Mast/forgotpassword",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      if (response.ok) {
        //console.log('OTP sent to email');
        setEmail(data.email);
        setStep("newPassword");
        setShowPasswordForm(true);
        resetEmailForm();
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Email not found",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error during forgot password request:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while sending OTP",
        life: 3000,
      });
    }
    setLoading(false);
  };

  const onSubmitOTP = async (data: any) => {
    try {
      setLoading(true);
      const response = await fetch(baseUrl + "External_User_Mast/verifyotp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: sessionStorage.getItem("resetEmail"),
          otp: data.otp,
        }),
      });
      if (response.ok) {
        //console.log('OTP verified successfully');
        sessionStorage.removeItem("step");
        setStep("newPassword");
        setShowPasswordForm(true);
        resetOtpForm();
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Invalid OTP",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while verifying OTP",
        life: 3000,
      });
    }
    setLoading(false);
  };

  const onSubmitNewPassword = async (data: any) => {
    try {
      setLoading(true);
      const newPasswordData = {
        email: sessionStorage.getItem("resetEmail"),
        newPassword: data.newPassword,
      };

      const response = await fetch(
        baseUrl + "External_User_Mast/resetpassword",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newPasswordData),
        }
      );
      if (response.ok) {
        //console.log('Password reset successfully');
        setStep("success");
        resetNewPasswordForm();
        setDone(false);
        handleGoToLogin();
        sessionStorage.clear();
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Password reset failed",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error during password reset:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while resetting password",
        life: 3000,
      });
    }
    setLoading(false);
  };

  const handleGoToLogin = () => {
    window.location.href = "/";
  };

  return (
    <div className="flex align-items-center justify-content-center h-screen">
      <Toast ref={toast} />
      <div className="surface-card p-4 shadow-2 border-round  lg:w-4">
        <div className="text-center mb-5">
          <img
            src="img/logo.png"
            alt="logo"
            height={50}
            width={250}
            className="mb-3"
          />
        </div>
        {/* {step === "email" && (
          <form
            onSubmit={handleEmailSubmit(onSubmitEmail)}
            className="p-fluid formgrid grid mt-6 "
          >
            <JVInput
              column={1}
              label="Email"
              control={emailControl}
              name="email"
              //   error={emailErrors.email?.message}
            />
            <div className="col-12 md:col-12 mt-6 text-center">
              <Button
                type="submit"
                loading={loading}
                label="Submit"
                icon="pi pi-envelope"
                className="w-full"
              />
            </div>
          </form>
        )} */}
        {sessionStorage.getItem("step") == "otp" && (
          <form
            onSubmit={handleOtpSubmit(onSubmitOTP)}
            className="p-fluid formgrid grid mt-6 "
          >
            <p style={{ fontWeight: "bold", color: "red", textAlign: "center" }}>An OTP has been sent to your mail id, please check and enter otp here.</p>

            <JVInput
              column={1}
              label="OTP"
              control={otpControl}
              name="otp"
            //   error={otpErrors.otp?.message}
            />
            <div className="col-12 md:col-12 mt-6 text-center">
              <Button
                type="submit"
                loading={loading}
                label="Verify OTP"
                icon="pi pi-check"
                className="w-full"
              />
            </div>
          </form>
        )}

        {step === "newPassword" && (
          <form
            onSubmit={handleNewPasswordSubmit(onSubmitNewPassword)}
            className="p-fluid formgrid grid mt-6 "
          >
          
            <JVPasswordInput
              column={1}
              label="New Password"
              control={newPasswordControl}
              name="newPassword"
              error={errors?.newPassword?.message}
              type="password" 
            />

            <JVPasswordInput
              column={1}
              label="Confirm Password"
              control={newPasswordControl}
              name="confirmPassword"
              error={errors?.confirmPassword?.message}
              type="password" 
            />
            <div className="col-12 md:col-12 mt-6 text-center">
              {done && (
                <Button
                  type="submit"
                  loading={loading}
                  label="Reset Password"
                  icon="pi pi-key"
                  className="w-full"
                />
              )}
            </div>
          </form>
        )}

        {step === "success" && (
          <div className="text-center">
            <p>Your password has been reset successfully.</p>
            <Button
              label="Go to Login"
              icon="pi pi-sign-in"
              className="w-full"
              onClick={handleGoToLogin}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
